import React, { useMemo } from "react";
import { HeaderGroup } from "react-table";
import { Select, SimpleGrid, Text } from "@chakra-ui/react";
import { SelectFilter as EagerSelectFilter } from "../Filters";
import { SelectOption } from "./SelectOption";
import { FilterOptions } from "./FilterOptions";
import LazySelectFilter from "./LazySelectFilter";

interface Props {
  column: HeaderGroup;
}

export function selectOptionsFromEnum(enumType: any): SelectOption[] {
  type indexKey = keyof typeof enumType;
  console.log('selectOptionsFromEnum 1',
              (Object.keys(enumType) as indexKey[])
                .map((key: indexKey) => enumType[key])
  );
  console.log('selectOptionsFromEnum 2',
              (Object.keys(enumType) as indexKey[])
                .map((enumIndex: indexKey, ) => {
                  return {
                    id: enumIndex,
                    displayValue: enumType[enumIndex]
                  } as SelectOption;
                })
  );
  return (Object.keys(enumType) as indexKey[])
      .map((enumIndex: indexKey, ) => {
      return {
        id: enumIndex,
        displayValue: enumType[enumIndex]
      } as SelectOption;
    });
};

const SelectFilter = (options: SelectOption[]): React.FC<Props> => {
  return (props: Props) => {
    return (
      (options && options.length > 0) ?
        <LazySelectFilter options={options} {...props} />
        :
        <text> ...loading</text>
    )
  }

}

export default SelectFilter;
